<div class="md-checkbox">
    <input id="{{id}}" type="checkbox" [value]="checked" [(ngModel)]="checked" (change)="boxchecked($event)">
    <label for="{{id}}">
      I have read and accept the 
      <a href="/policies/terms-of-use" target="_blank">Terms & Conditions</a> and 
      <a href="/policies/privacy-policy" target="_blank">Privacy Policy</a>
    </label>
</div>



<!--
  <div *ngIf="checkBoxForm.controls['check'].errors && checkBoxForm.controls['check'].touched"
  class="error-msg">
  <div [hidden]="!checkBoxForm.controls['check'].errors.required">Check is Required.</div>
  </div>


  <input
  matInput 
   formControlName="check" 
   name="check" 
   id="{{id}}"
   type="checkbox" 
   [value]="checked"
   [(ngModel)]="checked"
   (change)="boxchecked($event)">
-->
